var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"c-login"},[_c('div',{staticClass:"c-login__body"},[_c('app-intro',[_c('h1',[_vm._v("Wachtwoord vergeten?")]),_c('h3',[_vm._v("Vul uw e-mailadres in en u krijgt een e-mail met instructies")])]),_c('forgot-password-reset-form')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }